<template>
  <el-table-column
    prop="address.city"
    label="Város"
    show-overflow-tooltip
    min-width="150"
    sortable="custom"
  >
    <template slot-scope="scope">
      <div v-if="scope.row.address && scope.row.address.city" style="display: inline-block;">
        {{ scope.row.address.city }}
      </div>
      <div v-else>-</div>
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'address.city',
  };
</script>
